import { useState, useEffect } from "react";
import "./FormQuestion.css";
import { iconPath, Question, QuestionType } from "effno-core";
import { useSelector } from "react-redux";
import { selectUIStates, selectUser, setEditingForm, setEditingQuestionId } from "../../redux/features/appData";
import { QUESTION_IMAGES } from "../config/forms";
import FormQuestionMenu from "./FormQuestionMenu";
import { useDispatch } from "react-redux";
import { useDrag } from 'react-dnd'
import { DroppableSpacerTypes } from "../form-sidebar/DroppableSpacer";
import { FormQuestionTag, QuestionTypeIconColors } from "./FormQuestionTag";
import config from "environment";
import { MessageSquare } from "lucide-react";

const debugMode = config.debugMode;

interface DropResult {
    name: string;
    position: number;
}

type FormQuestionProps = {
    question: Question;
    questionNumber?: number;
    allowMenu?: boolean;
    isSelected?: boolean;
    onMove?: (questionId: string, position: number) => void;
    onDelete?: (questionId: string) => void;
}   

export const FormQuestion = ({
    question,
    questionNumber = 0,
    allowMenu = true,
    isSelected = false,
    onMove,
    onDelete
} : FormQuestionProps) => {

    const uiStates = useSelector(selectUIStates);

    const [{ isDragging }, drag] = useDrag(() => ({
        type: (question.type === QuestionType.END ? "end" : "question") as DroppableSpacerTypes,
        item: { id: question.id },
        end: (item, monitor) => {
          const dropResult = monitor.getDropResult<DropResult>()
          console.log("dropResult/item: ", item);
          console.log("dropResult/dropResult: ", dropResult);

          if (item && dropResult) {
            console.log(`You dropped ${item.id} into ${dropResult.name}!`);
            // alert("stop here 1")
            if (onMove) {
                onMove(item.id, dropResult.position);
            }
          }
        },
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
          handlerId: monitor.getHandlerId(),
        }),
      }))

    const dispatch = useDispatch();

    const storeUser = useSelector(selectUser);

    const handleSelectQuestion = () => {
        dispatch(setEditingQuestionId(question.id));
    }

    // need to catch changes so we update dragging info
    useEffect(() => {
        // console.log("FormQuestion: ", question);
    }, [setEditingForm])

    const opacity = isDragging ? 0.4 : 1

    // const title = question.title + debugMode ? " (" + question.id.substring(0,4) + ")" : "";
    const title = question.title;

    console.log("FormQuestion: onMove: ", onMove);
    
    return (
        <div 
            key={"form-question" + question.id}
            ref={onMove ? drag : undefined}
            className={`form-question ${isSelected ? "form-question-selected" : ""}`}
            style={{
                backgroundColor: QuestionTypeIconColors[question.type],
                ...(isDragging ? 
                    {
                        opacity,
                        borderRadius: "6px",
                    } : {}
                )
            }}
            onClick={handleSelectQuestion}
            data-testid={"question#" + question.id}
        >
            <FormQuestionTag type={question.type} />
            {/* <div className="form-question-type">
                <img src={iconPath(QUESTION_IMAGES[question.type], storeUser)} />
            </div> */}
            <div className="form-question-title">
                {questionNumber ? `${questionNumber}. ` : ""}{title}
            </div>
            {allowMenu && !uiStates.viewingComments &&
                <div 
                    className="form-question-menu-container"
                    data-testid={"question-menu#" + question.id}
                >
                    <FormQuestionMenu 
                        key={"form-question-menu-" + question.id}   
                        questionId={question.id}
                        isEndType={question.type === QuestionType.END}
                        onDelete={onDelete}
                    />
                </div>
            }
            {uiStates.viewingComments && question.comments && question.comments.length > 0 &&
                <div className="form-question-comments">
                    <MessageSquare size={16}/>
                </div>
            }
        </div>
    )
}